import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getEventById } from 'apis/events';
import { EVENTS } from 'common/routes';
import { encodeToBase64 } from 'utils/encodeAndDecode';

// Older dashboard responses contain an event ID and title but no slug.
export default function EventPreviewById() {
    const { eventId } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        let active = true;
        setError(false);
        const resolveEvent = async () => {
            try {
                const response = await getEventById(eventId);
                if (!active) return;
                if (!response?.success || !response.data?.slug) throw new Error('Event unavailable');
                navigate(`${EVENTS.VIEW_EVENT}/${encodeURIComponent(encodeToBase64(response.data.slug))}`, { replace: true });
            } catch {
                if (active) setError(true);
            }
        };
        resolveEvent();
        return () => { active = false; };
    }, [eventId, navigate, attempt]);

    return <main className="flex min-h-screen flex-col items-center justify-center gap-4 bg-gray-50 text-gray-600">
        {error ? <>
            <p role="alert">Could not open this event. It may be unavailable or your connection may have failed.</p>
            <button type="button" onClick={() => setAttempt(value => value + 1)} className="rounded-lg bg-white px-4 py-2 text-blue-600 shadow-sm">Retry</button>
        </> : <p role="status">Opening event…</p>}
    </main>;
}
